// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IV1BookCoworkingRequestSchema {
  /** ID коворкинга **/
  coworkingId: number;
  /** Тип объявления в коворкинге **/
  coworkingOfferType: ECoworkingOfferType;
  /** Запрос от брокера **/
  isBroker: boolean;
  /** Имя пользователя **/
  name: string;
  /** Телефон пользователя **/
  phone: string;
  /** Срок аренды **/
  rentDuration: number;
  /** Единица измерения срока аренды **/
  rentDurationUnit: ERentDurationUnit;
  /** Дата начала аренды **/
  rentStartDate: string;
  /** Количество рабочих мест **/
  workplaceCount: number;
}
export enum ECoworkingOfferType {
  /** Закрепленное рабочее место **/
  'FixedWorkplace' = 'fixedWorkplace',
  /** Незакрепленное рабочее место **/
  'FlexibleWorkplace' = 'flexibleWorkplace',
  /** Отдельный офис **/
  'Office' = 'office',
}
export enum ERentDurationUnit {
  /** День **/
  'Day' = 'day',
  /** Месяц **/
  'Month' = 'month',
}
